import React, { FC } from "react";

import { IconName, iconsMap } from "./icons-map";

export interface IconProps extends React.SVGProps<SVGSVGElement> {
  icon: IconName;
  /**
   * Icon size, default is `24px`
   */
  size?: number;
}

export const Icon: FC<IconProps> = ({ icon, size = 24, ...props }) => {
  const IconComponent = iconsMap[icon];

  return <IconComponent width={size} height={size} {...props} />;
};
